import { DASHBOARD_GRAPH } from "../../actions/type";

export default function dashboardGraph(state = [], action) {
    switch (action.type) {
        case DASHBOARD_GRAPH:
            return action.payload;
        default:
            return state
    }
}